import { CLICK_ACTIONS } from "../../utils/Constant";
import { ColumnHeaderType } from "../../utils/Types";
import { blankValueGetter, groupNameGetter, userNameValueGetter, userStatusValueGetter} from "../../utils/Util";

export const USER_ACCESS_HEADERS: ColumnHeaderType[] = [
    {
        name: 'Name',
        field: 'firstName',
        sortable: false,
        valueGetter: userNameValueGetter,
        action: CLICK_ACTIONS.VIEW_USER,
        clickable: true,
    },  
    {
        name: 'Phone',
        field: 'mobile',
        sortable: false,
        valueGetter: blankValueGetter,
        clickable: false,
    },
    {
        name: 'Email ID',
        field: 'email',
        sortable: false,
        valueGetter: blankValueGetter,
        clickable: false,
    },
    {
        name: 'Role',
        field: 'groupName',
        sortable: false,
        valueGetter: groupNameGetter,
        clickable: false,
    },
    {
        name: 'User Status',
        field: 'status',
        sortable: false,
        valueGetter: userStatusValueGetter,
        clickable: true,
    }
];